import { cn } from '@/app/lib/utils';
import { PanelLeft } from 'lucide-react';
import { Button } from '../ui/Button';

interface SidebarToggleButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
}

export default function SidebarToggleButton({
  label,
  onClick,
  className,
}: SidebarToggleButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      className={cn('h-6 w-6 shrink-0 text-muted-foreground', className)}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <PanelLeft size={16} />
    </Button>
  );
}
